<template>
  <div class="col-12">
    <div class="card mb-5 " style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px;">
        <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">
              {{ $t('question_forms.templates_title') }}
            </h6>
          </div>
        </div>
      </div>
   
      <div class="card-body px-0 pb-2">
        <div class="row justify-content-center">
          <div class="col-12">
            <QuestionFormForm 
              ref="questionFormForm"
              :title="$t('question_forms.add_new_template')"
              :submit-text="$t('question_forms.submit_template')"
              :loading="isSubmitting"
              @submit="handleSubmit" 
              @cancel="handleCancel" 
              @validation-error="handleValidationError"
            />
            
          
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import QuestionFormForm from '@/components/features/question-forms/QuestionFormForm.vue';
import { useToast } from 'vue-toastification';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const toast = useToast();
const router = useRouter();
const store = useStore();
const questionFormForm = ref(null);
const isSubmitting = ref(false);

const handleSubmit = async (formData) => {
  if (!formData && questionFormForm.value) {
    if (questionFormForm.value.submitForm) {
      questionFormForm.value.submitForm();
      return;
    }
    toast.error(t("question_forms.form_error_cannot_save"));
    return;
  }

  if (!formData) {
    toast.error(t("question_forms.no_data_to_save"));
    return;
  }

  isSubmitting.value = true;
  try {
    await store.dispatch('questionForms/createQuestionForm', formData);
    toast.success(t("question_forms.added_successfully"));
    router.push('/question-forms');
  } catch (error) {
    if (error.response && error.response.status === 422) {
      const errors = error.response.data.errors;
      for (const field in errors) {
        toast.error(errors[field][0]);
      }
    } else {
      toast.error(error.response?.data?.message || t("question_forms.error_while_adding"));
    }
  } finally {
    isSubmitting.value = false;
  }
};

const handleValidationError = () => {
  toast.warning(t("question_forms.fill_all_fields_correctly"));
};

const handleCancel = () => {
  if (!isSubmitting.value) {
    router.push('/question-forms');
  }
};
</script>